import { defineNuxtPlugin, useRuntimeConfig } from '#app';

export default defineNuxtPlugin(async(nuxtApp) => {
  const clientId = useRuntimeConfig().public.googleAuthClientId;
  if (clientId) {
    const plugin = await import('vue3-google-signin');
    nuxtApp.vueApp.use(plugin.default, { clientId });
  }
});
